export default __webpack_public_path__ + "static/media/solucao-03.3773cee0.webp";